var _path, _ellipse, _ellipse2, _path2, _path3, _path4, _line, _line2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReverseTrackingMechanism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9375 22.9881H34.3938C36.5208 22.9881 38.2451 24.7123 38.2451 26.8393V32.0726C38.2451 34.1996 36.5208 35.9238 34.3938 35.9238H21.9375",
    stroke: "#161614",
    strokeWidth: 3.75
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.92562,
    cy: 1.9256,
    rx: 1.92562,
    ry: 1.9256,
    transform: "matrix(-1 0 0 1 33.6914 27.4805)",
    fill: "#161614"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.92562,
    cy: 1.9256,
    rx: 1.92562,
    ry: 1.9256,
    transform: "matrix(-1 0 0 1 27.1758 27.4805)",
    fill: "#161614"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.824 22.8984L49.0085 29.2756C49.0933 29.4049 49.0926 29.5724 49.0067 29.7009L44.824 35.9577",
    stroke: "#F30002",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5661 22.8984L57.7507 29.2756C57.8355 29.4049 57.8348 29.5724 57.7489 29.7009L53.5661 35.9577",
    stroke: "#F30002",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9889 53.0551L19.0936 46.9969C18.9437 46.8429 18.6968 46.8413 18.545 46.9934L9.186 56.371C7.33729 58.2234 7.40232 61.2422 9.32909 63.0133C11.1457 64.683 13.9556 64.624 15.7004 62.8794L24.9852 53.596C25.1342 53.4471 25.1359 53.2061 24.9889 53.0551Z",
    stroke: "#161614",
    strokeWidth: 3.75,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1.875,
    x2: 4.36025,
    y2: -1.875,
    transform: "matrix(-0.713336 0.700822 0.700829 0.713329 25.6172 44.8887)",
    stroke: "#161614",
    strokeWidth: 3.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1.875,
    x2: 4.63611,
    y2: -1.875,
    transform: "matrix(-0.712966 0.701199 0.701205 0.712959 29.9883 49.1426)",
    stroke: "#161614",
    strokeWidth: 3.75
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9357 29.5632C20.9357 41.5412 30.6459 51.2514 42.6241 51.2514C54.6023 51.2514 64.3125 41.5412 64.3125 29.5632C64.3125 17.5852 54.6023 7.875 42.6241 7.875C30.6459 7.875 20.9357 17.5852 20.9357 29.5632Z",
    stroke: "#161614",
    strokeWidth: 3.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseTrackingMechanism);
export default __webpack_public_path__ + "static/media/Reverse-Tracking-Mechanism.422f14d847f5461316fd7d665acc85c8.svg";
export { ForwardRef as ReactComponent };